import { render, staticRenderFns } from "./HotLab.vue?vue&type=template&id=e7002946&scoped=true&"
import script from "./HotLab.vue?vue&type=script&lang=js&"
export * from "./HotLab.vue?vue&type=script&lang=js&"
import style0 from "./HotLab.vue?vue&type=style&index=0&id=e7002946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7002946",
  null
  
)

export default component.exports